import React, {useMemo} from 'react';
import {ReactComponent as UploadIcon} from '../../../../assets/icons/upload.svg';
import {useDropzone} from 'react-dropzone';
import {acceptGeneralFormats, convertSizeToMB} from '../../../../helpers/functions';
import {notifyError} from '../../../../helpers/notifySnack';
import {useTranslation} from 'react-i18next';

const FileField = ({
  avatar,
  allowFormats,
  acceptedFiles,
  dropText,
  maxSizeMb,
  setAcceptedFiles,
  onFilesAdded,
  disabled
}) => {
  const {t} = useTranslation();

  const getFileExtension = (filename) => {
    return filename.slice(((filename.lastIndexOf('.') - 1) >>> 0) + 2).toLowerCase();
  };

  const maxSizeValidator = (file) => {
    if (!file) return;
    const fileExtension = getFileExtension(file.path || file.name);

    if (!allowFormats.includes(`.${fileExtension}`)) {
      notifyError(`${t('DropzoneMultiple.fileFormatError')}`);
      return {
        code: 'invalid format'
      };
    }

    if (file && convertSizeToMB(file.size) > maxSizeMb) {
      notifyError(`${t('DropzoneMultiple.fileSize')} ${maxSizeMb}MB`);
      return {
        code: 'large size'
      };
    }
    return null;
  };

  const onDrop = (newFiles) => {
    newFiles.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file)
      })
    );
    setAcceptedFiles(newFiles);
    onFilesAdded(newFiles);
  };

  const filteredFormats = useMemo(() => {
    return Object.fromEntries(
      Object.entries(acceptGeneralFormats).filter(([key, extensions]) =>
        extensions.some((ext) => allowFormats.includes(ext))
      )
    );
  }, [acceptGeneralFormats, allowFormats, t]);

  const {getRootProps, getInputProps} = useDropzone({
    onDrop,
    maxFiles: 1,
    validator: maxSizeValidator,
    accept: filteredFormats
  });

  return (
    <div
      {...getRootProps({
        className: `dropzone-multiple__input-file dropzone-multiple__input ${
          (avatar && Object.keys(avatar).length) || disabled ? 'disabled' : ''
        } ${acceptedFiles.length > 0 ? 'has-trash' : ''}`,
        accept: '.pdf',
        onClick: (event) => {
          ((avatar && Object.keys(avatar).length) || disabled) && event.stopPropagation();
        }
      })}
    >
      <input {...getInputProps()} />
      <div className={`dropzone-multiple-content`}>
        <div className='dropzone-multiple__icon'>
          {acceptedFiles.length > 0 ? (
            <img
              src={acceptedFiles[0].preview}
              onLoad={() => URL.revokeObjectURL(acceptedFiles[0].preview)}
              alt='Preview'
            />
          ) : (
            <UploadIcon />
          )}
        </div>
        <p className='dropzone-multiple-text'>
          {acceptedFiles.length > 0 ? t('DropzoneMultiple.anotherPhoto') : dropText}
        </p>
      </div>
    </div>
  );
};

export default FileField;
